import PatientsMobile from './patients-mobile';

export default PatientsMobile;
